import axiosService from '@Lib/axiosService';
import { handleResponse } from '@Utils/helpers';

let url = '';
if (process.env.DASHBOARD_TYPE === 'admin') {
  url = `${process.env.API_ADMIN_URL}/securities`;
}

export const securitieIndex = async () => {
  const res = await axiosService.get(`${url}/list`);
  return handleResponse(res);
};
